<template>
    <div class="container" id="solutions" >
    <div class="solutions">  
        <div class="title wow fadeInUp" data-wow-delay="0.3s"> 
            <h1>
                <img class="left_border" src="./img/border.png">{{$t("industry.title")}}<img class="right_border" src="./img/border.png">
            </h1>
            <h3>{{$t("industry.title_text")}}</h3>
            <div class="clearfix"> </div>
        </div> 
        
        <!-- from Salesforce -->
        <div class="salesforce">
            <div class="solutions-row solutions-row-salesforce row">
                <div style="width: 100%;">
                    <div class="heading wow fadeInUp" data-wow-delay="0.3s">
                        <h1 class="title">{{$t("industry.Salesforce_industy_titie")}}</h1>
                        <hr class="line">
                    </div>
                </div>
                <div class="clearfix wow fadeInUp saleforce-text" data-wow-delay="0.3s">{{$t("industry.Salesforce_industy_des")}} </div>
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.3s">
                    <a  class="imghvr-hinge-right imghvr-hinge-right-Salesforce figure">
                        <img src="./img/solutions-1-1.png" alt="" title="Smart Buzz Image"/> 
                        <div class="agile-figcaption">
                          <h4>{{$t("industry.Salesforce_industy1")}}</h4>
                          <p>{{$t("industry.Salesforce_industy1_text1")}}</p>
                        </div>
                    </a> 
                </div> 
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.4s">
                    <a class="imghvr-hinge-right imghvr-hinge-right-Salesforce figure">
                        <img src="./img/solutions-1-2.png" alt="" title="Smart Buzz Image"/> 
                        <div class="agile-figcaption">
                           <h4>{{$t("industry.Salesforce_industy2")}}</h4>
                          <p>{{$t("industry.Salesforce_industy2_text1")}}</p>
                        </div>
                    </a> 
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.5s">
                    <a  class="imghvr-hinge-right imghvr-hinge-right-Salesforce figure">
                        <img src="./img/solutions-1-3.jpg" alt="" title="Smart Buzz Image"/> 
                        <div class="agile-figcaption">
                            <h4>{{$t("industry.Salesforce_industy3")}}</h4>
                          <p>{{$t("industry.Salesforce_industy3_text1")}}</p>
                        </div>
                    </a> 
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids Salesforce_industy_info wow fadeInUp" data-wow-delay="0.3s">
                    <div class="tm-popular-item-description">
                        <h4 class="tm-handwriting-font tm-popular-item-title">{{$t("industry.Salesforce_industy1")}}</h4>
                        <ul>
                            <li>{{$t("industry.Salesforce_industy1_text1")}}</li>
                            <li>{{$t("industry.Salesforce_industy1_text2")}}</li>
                            <li>{{$t("industry.Salesforce_industy1_text3")}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids Salesforce_industy_info wow fadeInUp" data-wow-delay="0.3s">
                    <div class="tm-popular-item-description">
                        <h4 class="tm-handwriting-font tm-popular-item-title">{{$t("industry.Salesforce_industy2")}}</h4>
                        <ul>
                            <li>{{$t("industry.Salesforce_industy2_text1")}}</li>
                            <li>{{$t("industry.Salesforce_industy2_text2")}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12 solutions-grids Salesforce_industy_info wow fadeInUp" data-wow-delay="0.3s">
                    <div class="tm-popular-item-description">
                        <h4 class="tm-handwriting-font tm-popular-item-title">{{$t("industry.Salesforce_industy3")}}</h4>
                        <ul>
                            <li>{{$t("industry.Salesforce_industy3_text1")}}</li>
                            <li>{{$t("industry.Salesforce_industy3_text2")}}</li>
                            <li>{{$t("industry.Salesforce_industy3_text3")}}</li>
                            <li>{{$t("industry.Salesforce_industy3_text4")}}</li>
                        </ul>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-- from Salesforce end-->


        <div class="solutions-row">
            <div>
                <div class="heading wow fadeInUp" data-wow-delay="0.3s">
                    <h1 class="title">{{$t("industry.ins_title")}}</h1>
                    <hr class="line">
                </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.3s">
                <a  class="imghvr-hinge-right figure">
                    <img src="./img/solutions-1.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.automative")}}</h4>
                      <p>{{$t("industry.automative_text")}}</p>
                    </div>
                </a> 
            </div> 
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.4s">
                <a class="imghvr-hinge-right figure">
                    <img src="./img/solutions-2.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.communication")}}</h4>
                      <p>{{$t("industry.communication_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.5s">
                <a  class="imghvr-hinge-right figure">
                    <img src="./img/solutions-3.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.financial")}}</h4>
                      <p>{{$t("industry.financial_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.6s">
                <a  class="imghvr-hinge-right figure">
                    <img src="./img/solutions-4.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.medical")}}</h4>
                      <p>{{$t("industry.medical_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.7s">
                <a  class="imghvr-hinge-right figure">
                    <img src="./img/solutions-5.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.media")}}</h4>
                      <p>{{$t("industry.media_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.8s">
                <a class="imghvr-hinge-right figure">
                    <img src="./img/solutions-6.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.retail")}}</h4>
                      <p>{{$t("industry.retail_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="0.9s">
                <a class="imghvr-hinge-right figure">
                    <img src="./img/solutions-7.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.education")}}</h4>
                      <p>{{$t("industry.education_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 solutions-grids wow fadeInUp" data-wow-delay="1.0s">
                <a class="imghvr-hinge-right figure">
                    <img src="./img/solutions-8.jpeg" alt="" title="Smart Buzz Image"/> 
                    <div class="agile-figcaption">
                      <h4>{{$t("industry.manufacturing")}}</h4>
                      <p>{{$t("industry.manufacturing_text")}}</p>
                    </div>
                </a> 
            </div>
            <div class="clearfix"></div>
        </div>

        <div class="pattern">
            <div>
                <div class="heading wow fadeInUp" data-wow-delay="0.3s">
                    <h1 class="title">{{$t("industry.pattern_title")}}</h1>
                    <hr class="line">
                </div>
            </div>
            <div class="tm-popular-items-container">
            <div class="tm-popular-item col-lg-5 col-sm-12 col-md-5 wow fadeInUp" data-wow-delay="0.3s">
              <img src="./img/pattern_1.jpg" class="tm-popular-item-img">
              <div class="tm-popular-item-description">
                <h3 class="tm-handwriting-font tm-popular-item-title">{{$t("industry.pattern_item1")}}</h3>
                <hr class="tm-popular-item-hr">
                <p>{{$t("industry.pattern_item1_text1")}}</p>
                <p>{{$t("industry.pattern_item1_text2")}}</p>
                <p>{{$t("industry.pattern_item1_text3")}}</p>
                <p>{{$t("industry.pattern_item1_text4")}}</p>
                <div class="order-now-container">
                  <a href="#" class="order-now-link tm-handwriting-font">{{$t("industry.pattern_item1_title")}}</a>
                </div>
              </div>              
            </div>
            <div class="vs-item col-lg-2 col-sm-12 col-md-2 wow fadeInUp" data-wow-delay="0.3s">
                <img src="./img/vs.png">
            </div>
            <div class="tm-popular-item col-lg-5 col-sm-12 col-md-5 wow fadeInUp" data-wow-delay="0.3s">
              <img src="./img/pattern_2.jpg" alt="Popular" class="tm-popular-item-img">
              <div class="tm-popular-item-description">
                <h3 class="tm-handwriting-font tm-popular-item-title">{{$t("industry.pattern_item2")}}</h3><hr class="tm-popular-item-hr">
                <p>{{$t("industry.pattern_item2_text1")}}</p>
                <p>{{$t("industry.pattern_item2_text2")}}</p>
                <p>{{$t("industry.pattern_item2_text3")}}</p>
                <p>{{$t("industry.pattern_item2_text4")}}</p>
                <div class="order-now-container">
                  <a href="#" class="order-now-link tm-handwriting-font">{{$t("industry.pattern_item2_title")}}</a>
                </div>
              </div>              
            </div>
          </div> 
        </div>

        <div class="flow">
            <div>
                <div class="heading wow fadeInUp" data-wow-delay="0.3s">
                    <h1 class="title">{{$t("industry.flow_title")}}</h1>
                    <hr class="line">
                </div>
            </div>
            <div class="row">
                <div class="box-item col-lg-4 col-sm-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div>
                        <div class="wrap-icon">
                            <div class="hexagon">
                                <div class="hexagon-inner">
                                    <div class="hexagon-inner-content">
                                        <span class="flow-icon fa fa-comments-o fa-3x"></span>
                                    </div>
                                </div>
                                <span></span>
                            </div>
                        </div>
                        <h3>{{$t("industry.flow_flow1_title")}}</h3>
                        <p>{{$t("industry.flow_flow1_text")}}</p>
                    </div>
                </div>
                <div class="box-item col-lg-4 col-sm-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                    <div>
                        <div class="wrap-icon">
                            <div class="hexagon">
                                <div class="hexagon-inner">
                                    <div class="hexagon-inner-content">
                                        <span class="flow-icon fa fa-lock fa-3x"></span>
                                    </div>
                                </div>
                                <span></span>
                            </div>
                        </div>
                        <h3>{{$t("industry.flow_flow2_title")}}</h3>
                        <p>{{$t("industry.flow_flow2_text")}}</p>
                    </div>
                </div>
                <div class="box-item col-lg-4 col-sm-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                    <div>
                        <div class="wrap-icon">
                            <div class="hexagon">
                                <div class="hexagon-inner">
                                    <div class="hexagon-inner-content">
                                        <span class="flow-icon fa fa-check-square-o fa-3x"></span>
                                    </div>
                                </div>
                                <span></span>
                            </div>
                        </div>
                        <h3>{{$t("industry.flow_flow3_title")}}</h3>
                        <p>{{$t("industry.flow_flow3_text")}}</p>
                    </div>
                </div>
                <div class="box-item col-lg-4 col-sm-3 col-md-6 wow fadeInUp" data-wow-delay="0.8s">
                    <div>
                        <div class="wrap-icon">
                            <div class="hexagon">
                                <div class="hexagon-inner">
                                    <div class="hexagon-inner-content">
                                        <span class="flow-icon fa fa-thumbs-o-up fa-3x"></span>
                                    </div>
                                </div>
                                <span></span>
                            </div>
                        </div>
                        <h3>{{$t("industry.flow_flow4_title")}}</h3>
                        <p>{{$t("industry.flow_flow4_text")}}</p>
                    </div>
                </div>
                <div class="box-item col-lg-4 col-sm-3 col-md-6 wow fadeInUp" data-wow-delay="0.9s">
                    <div>
                        <div class="wrap-icon">
                            <div class="hexagon">
                                <div class="hexagon-inner">
                                    <div class="hexagon-inner-content">
                                        <span class="flow-icon fa fa-bolt fa-3x"></span>
                                    </div>
                                </div>
                                <span></span>
                            </div>
                        </div>
                        <h3>{{$t("industry.flow_flow5_title")}}</h3>
                        <p>{{$t("industry.flow_flow5_text")}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="w3lspvt-tec-row row  text-center pt-md-0 pt-5 mt-lg-5">
            <div style="width: 100%;margin-bottom: 50px;">
                <div class="heading wow fadeInUp" data-wow-delay="0.3s">
                    <h1 class="title">{{$t("industry.tec_title")}}</h1>
                    <hr class="line">
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 w3lspvt-about-grids  my-sm-0 my-5 wow fadeInUp" data-wow-delay="1.5s">
                <div class="p-md-5 p-sm-3">
                    <!-- <span class="fa fa-check-circle-o"></span> -->
                    <img class="arrows" src="./img/tec_2.png" />
                    <h4 class="mt-2 mb-3">{{$t("industry.heading2")}}</h4>
                    <p>{{$t("industry.heading2_text1")}}</p>
                    <p>{{$t("industry.heading2_text2")}}</p>
                    <p>{{$t("industry.heading2_text3")}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 w3lspvt-about-grids  border-left border-right wow fadeInUp" data-wow-delay="1.6s">
                <div class="p-md-5 p-sm-3">
                    <img class="arrows" src="./img/tec_1.png" />
                    <h4 class="mt-2 mb-3">{{$t("industry.heading1")}}</h4>
                    <p>{{$t("industry.heading1_text1")}}</p>
                    <p>{{$t("industry.heading1_text2")}}</p>
                    <p>{{$t("industry.heading1_text3")}}</p>
                </div>
            </div>
            <div class="col-lg-4 w3lspvt-about-grids wow fadeInUp" data-wow-delay="1.7s">
                <div class="p-md-5 p-sm-3">
                    <!-- <span class="fa fa-paw"></span> -->
                    <img class="arrows" src="./img/tec_3.png" />
                    <h4 class="mt-2 mb-3">{{$t("industry.heading3")}}</h4>
                    <p>{{$t("industry.heading3_text1")}}</p>
                    <p>{{$t("industry.heading3_text2")}}</p>
                    <p>{{$t("industry.heading3_text3")}}</p>
                </div>
            </div>
        </div>
    </div>
    </div>
    
</template>
<script>
    // import '../../static/js/simple-lightbox.min.js'
    export default{
        mounted: function() {
            $(function(){
                    // var solutions = $('.solutions-row a').simpleLightbox({navText:       ['&lsaquo;','&rsaquo;']});
                });
        }
    }
</script>  
<style>
#solutions {
    padding-top: 78px;
    margin-top: -78px;
    /*padding-bottom: 0.8rem;*/
}
#solutions {
    font-size: 15px;
    /*height: 90vh;*/
}
#solutions .title h1 {
    font-size: 30px;
    /*font-weight: bold;*/
}
#solutions .title h3 {
    font-size: 18px;
    /*font-weight: bold;*/
}
.solutions h4{
    color: #e44c65;
}
.solutions p{
    margin:0;
    color:#726d70; 
}
.solutions {
    background: #fff;
    margin-bottom: 80px;
}
.solutions-grids {
    padding: 1em;
}
.title {
    padding-top: 12px;
    margin-top: 30px;
    margin-bottom: 30px;
    font-weight: bold;
    letter-spacing: 3px;
} 
/*-- imghvr-hinge --*/
[class^='imghvr-'],
[class*=' imghvr-'] {
    position: relative;
    display: inline-block;
    margin: 0px;
    max-width: 100%;
    background-color:#305577;
    color:#212121;
    overflow: hidden;
    -webkit-backface-visibility: hidden; 
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -o-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    cursor: pointer;
}
[class^='imghvr-'] > img,
[class*=' imghvr-'] > img {
    vertical-align: top;
    max-width: 100%;
}
[class^='imghvr-'] .agile-figcaption,
[class*=' imghvr-'] .agile-figcaption {
    background-color:#305577;
    /*padding:5.5em;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color:#212121;
    text-align: center;
} 
[class^='imghvr-'] .agile-figcaption h4{
    font-size:1.5em;
    margin-bottom:.5em;
    margin-top: 1.5em;
}
[class^='imghvr-'] .agile-figcaption p{
    line-height:2em;
    color:#fff;
    font-size: 1.0em;
}
[class^='imghvr-'] a,
[class*=' imghvr-'] a {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
}
[class^='imghvr-'],
[class*=' imghvr-'],
[class^='imghvr-']:before,
[class^='imghvr-']:after,
[class*=' imghvr-']:before,
[class*=' imghvr-']:after,
[class^='imghvr-'] *,
[class*=' imghvr-'] *,
[class^='imghvr-'] *:before,
[class^='imghvr-'] *:after,
[class*=' imghvr-'] *:before,
[class*=' imghvr-'] *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.35s ease;
    -moz-transition: all 0.35s ease;
    transition: all 0.35s ease;
}
[class^='imghvr-hinge-'],
[class*=' imghvr-hinge-'] {
    -webkit-perspective: 50em;
    perspective: 50em;
}
[class^='imghvr-hinge-'] .agile-figcaption,
[class*=' imghvr-hinge-'] .agile-figcaption {
    opacity: 0;
    z-index: 1;
}
[class^='imghvr-hinge-']:hover img,
[class*=' imghvr-hinge-']:hover img {
    opacity: 0;
}
[class^='imghvr-hinge-']:hover .agile-figcaption,
[class*=' imghvr-hinge-']:hover .agile-figcaption {
    opacity: 1;
    -webkit-transition-delay: 0.21s;
    -moz-transition-delay: 0.21s;
    -o-transition-delay: 0.21s;
    -ms-transition-delay: 0.21s;
    transition-delay: 0.21s;
}
 
/*-- imghvr-hinge-right -- */
.imghvr-hinge-right img {
    -webkit-transform-origin: 100% 50%;
    -ms-transform-origin: 100% 50%;
    -moz-transform-origin: 100% 50%;
    -o-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    
}

.Salesforce_industy_info div{
    min-height: 290px;
    /*overflow: scroll;*/
    background-color:#305577;
    color: white;
}
.Salesforce_industy_info li{
    text-align: left;
}
.imghvr-hinge-right .agile-figcaption {
    -webkit-transform: rotateY(90deg);
    -moz-transform-origin: 0 50%;
    -o-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    transform: rotateY(90deg);
    -webkit-transform-origin: 0 50%;
    -moz-transform-origin: 0 50%;
    -o-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    transform-origin: 0 50%;
}
.imghvr-hinge-right:hover > img {
    -webkit-transform: rotateY(-90deg);
    -moz-transform: rotateY(-90deg);
    -o-transform: rotateY(-90deg);
    -ms-transform: rotateY(-90deg);
    transform: rotateY(-90deg);
}
.imghvr-hinge-right:hover .agile-figcaption {
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    transform: rotateY(0deg);
}
.left_border {
    display: inline-block;
    width: 60px;
    margin-right: 50px;
}
.right_border {
    display: inline-block;
    width: 60px;
    margin-left: 40px;
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
}
.w3lspvt-about-grids {
    padding: 25px !important;
}
.w3lspvt-about-grids p {
    font-size: 15px;
    text-align: left;
}
.flow p {
    font-size: 15px;
    text-align: center;
}
.flow>div {
    margin-bottom: 50px;
}
.w3lspvt-about-grids h4 {
    text-transform: capitalize;
    font-weight: 600;
    letter-spacing: 1px;
    color: #2a419f;
    font-size: 1.3em;
}
.w3lspvt-about-grids span.fa {
    width: 70px;
    height: 70px;
    line-height: 70px;
    border-radius: 50%;
    background: #eee;
    margin-bottom: 1em;
    font-size: 1.5em;
}
.w3lspvt-about-grids:nth-child(3) span {
    color: #0fb492;
}
.w3lspvt-about-grids:nth-child(2) span {
    color: #f5ac43;
}
.w3lspvt-about-grids:nth-child(1) span {
    color: #634271;
}
.w3lspvt-about-grids.border-left.border-right {
    border-right: solid 1px rgb(222, 226, 230) !important;
    border-left: solid 1px rgb(222, 226, 230) !important;
}
.w3lspvt-about-grids.border-left.border-right{
    -moz-box-shadow: 0px 4px 16px 0px #808080;
    -webkit-box-shadow: 0px 4px 16px 0px #808080;
    box-shadow: 0px 4px 16px 0px #808080;
    -webkit-transform: translateY(-2%);
    transform: translateY(-2%);
}
.w3lspvt-tec-row {
    margin-top: 25px;
}
.w3lspvt-tec-row h4 {
    margin-top: 10px;
    color: #c67f7d;
}
.wrap-icon {
    background: #F0F3F6;
    padding-top: 17px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin:auto;
}
.hexagon {position: relative;width: 100px; height: 57.74px;background-color: #ffffff;margin: 28.87px auto;box-shadow: 0 0 15px rgba(0,0,0,0.4);}
.hexagon .hexagon-inner {display: block;position: absolute;bottom: 0;width: 100%;height: 100%;text-align: center;z-index: 999;}
.hexagon .hexagon-inner .hexagon-inner-content {position: absolute;top: 50%;width: 100%;text-align: center;transform: translateY(-50%);}

.hexagon:before,
.hexagon:after {content: "";position: absolute;z-index: 1;width: 70.71px;height: 70.71px;-webkit-transform: scaleY(0.5774) rotate(-45deg);-ms-transform: scaleY(0.5774) rotate(-45deg);transform: scaleY(0.5774) rotate(-45deg);background-color: inherit;left: 14.6447px;box-shadow: 0 0 15px rgba(0,0,0,0.4);}

.hexagon:before {top: -35.3553px;}

.hexagon:after {bottom: -35.3553px;}

/*cover up extra shadows*/
.hexagon span {display: block;position: absolute;top: 0;left: 0;width:100px;height:57.7350px;z-index: 2;background: #fff;}
.hexagon .flow-icon {
    position: relative !important;
    padding-top: 5px;
}
.flow h3 {
    font-size: 18px;
}
.tm-popular-item {
  background: url(./img/popular-item-bg.png) no-repeat;
  background-size: 100% 100%;
 /* width: 33.33%;
  max-width: 33.33%;*/
  margin-top: 30px;  
  margin-bottom: 80px;
  /*padding: 10px;*/
}
.tm-popular-item-img { 
    /*margin-left: 3px;*/
    overflow: hidden;
    width: 100%;
    height: 300px;
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 10px;
}
.tm-popular-item-description {
  padding: 0 30px 60px;
  position: relative;
  text-align: center;
}
.tm-popular-item-description p {
    font-size: 15px;
}
.tm-popular-item-title,
.tm-popular-items-container {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 40px;
}
.tm-handwriting-font {
    font-size: 20px !important;
    text-align: center !important;
    display: inline-block;
    padding: 15px;
}
.tm-popular-items-container:last-child { margin-top: 15px; }
.tm-popular-item:hover { background-image: url(./img/popular-item-bg-hover.png); }
.tm-popular-item .tm-popular-item-title { color: #aa6d6a; }
.tm-popular-item:hover hr {
  border-color: #c79c60;
  -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
}
.tm-popular-item:hover .order-now-link {
  border-color: #c79c60;
  color: #c79c60;
  text-decoration: none;
}
.tm-popular-item-title {
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 0;
}
.tm-popular-item-hr {
  margin-top: 0;
  margin-bottom: 15px;
}
.order-now-container {
  width: 100px;
  height: 100px;
  background-color: rgb(82, 76, 76);
  border-radius: 50%;
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: white;
  position: absolute;
  left: calc(50% - 50px);
  bottom: -50px;
}
.order-now-link {
  color: rgb(174,174,174);
  -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
}
.order-now-link {
  font-size: 15px !important;
  border: 2px solid rgb(174,174,174);
  border-radius: 50%;
  width: 90px;
  height: 90px;
  line-height: 20px;
  padding-top: 22px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.tm-popular-item:hover .order-now-link {
  border-color: #c79c60;
  color: #c79c60;
  text-decoration: none;
}
.vs-item {
    /*width: 100%;*/
    display: flex;
    align-items: center;
    justify-content: center;
}
.box-item {
    margin-bottom: 20px;
}
.row .box-item:nth-child(1),.row .box-item:nth-child(2),.row .box-item:nth-child(3) {
    min-height: 310px;
}
#solutions .salesforce .row {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
}
#solutions .salesforce .row > [class*='col-']  {
    display: -webkit-box;
    display: -ms-flexbox;
}
#solutions .heading {
    width: 100%;
}
.saleforce-text {
    line-height: 2;
}
@media only screen and (max-width: 768px) {
    .section-header {
        padding-top: 0px;
        margin-top: 0px;
        padding-bottom: 0px;
    }
    .section-header h3{
        font-size: 10px;
        padding:0;
        margin: 0;
    }
    .vs-item {
        width: 100%;
    }
    .row .box-item:nth-child(4) {
        min-height: 310px;
    }
}
@media only screen and (max-width: 768px) {
    #solutions .title {
        padding-top: 0px;
        margin-top: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    .title h3{
        font-size: 10px !important;
        padding:0;
        margin: 0;
        margin-bottom: 10px;
    }
    .solutions {
        margin-bottom: 30px;
    }
    .left_border,.right_border {
        display: none;
    }
    .saleforce-text {
        padding: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/industry.vue